<div class="flex mt-3 mb-3 flex-column lg:flex-row">
    <div class="text-0 cursor-pointer ml-auto" *ngIf="mode == loginMode.Login"
        (click)="sendRecoverPasswordVerification()">שכחת סיסמה?</div>
    <div class="mr-auto text-0 cursor-pointer" *ngIf="mode == loginMode.Login" (click)="changeView(loginMode.New)">משתמש
        חדש? הרשם ></div>
</div>
<div class="flex mr-auto text-0 cursor-pointer font-bold flex-wrap" *ngIf="mode == loginMode.Login">
   <span class="mx-1"> בכניסתי לאתר אני מאשר את</span>
    <a href="https://www.kesherhk.co.il/%d7%9e%d7%99%d7%93%d7%a0%d7%99%d7%95%d7%aa-%d7%a4%d7%a8%d7%98%d7%99%d7%95%d7%aa/"
        target="_blank" class="mx-1 underline white-color">תקנון האתר</a>
    <span class="mx-1">וקבלת דיוור</span>
</div>
<div class="flex my-2 gap-1">
    <p class="cursor-pointer text-white -mt-2 underline fade"
        *ngIf="mode == loginMode.Forgot || mode == loginMode.Verify" (click)="sendAgainClicked()">{{
        'VERIFICATION.SEND_AGAIN'|translate }}</p>
    <p class="cursor-pointer text-white -mt-2 underline fade" *ngIf="mode == loginMode.Verify"
        (click)="mailOrPhoneSendAgainClicked()">{{ getVerificationLabel() | translate }}</p>

    <!------ OK BUTTON ------>

    <p-button type="button" icon="" iconPos="right" [label]="getLabel() | translate" (onClick)="click()"
        class="p-button-raised p-button-text  buttonLogin mr-auto fade" #ok styleClass="secondaryFill"> </p-button>

    <!------ CANCEL BUTTON ------>

    <p-button *ngIf="showCancel()" type="button" icon="" iconPos="right" [label]="'GENERAL.CANCEL'|translate"
        styleClass="secondaryFill" (click)="cancelClick()"
        class="p-button-raised p-button-text p-button-plain buttonLogin fade">
    </p-button>

</div>